import { BestSellerProductType, BestSellerScaleType, ProductType } from '../../../../types/product';
import getBestSeller from '../get-best-seller';

const getProductIdListAndHasBestSeller = (
  loadingState: boolean,
  errorState: boolean,
  productData: { productsWithServices: ProductType['id'][] },
  productType: BestSellerProductType,
  scale: BestSellerScaleType,
): { productIds: ProductType['id'][]; hasBestSellerWithFewerInclusions: boolean } => {
  const productIds = productData?.productsWithServices ?? [];

  if (loadingState || errorState || productIds.length > 1) {
    return {
      hasBestSellerWithFewerInclusions: false,
      productIds,
    };
  }
  return { hasBestSellerWithFewerInclusions: true, productIds: [...productIds, getBestSeller({ productType, scale })] };
};

export default getProductIdListAndHasBestSeller;
